<button type="button"
        class="button button_no-margin"
        (click)="login()"
>
  <span>{{label}}</span>
  <span class="spot-icon spot-icon_external-link"></span>
</button>
